// CharacterForge — D&D 5e SRD 5.2 Spells (CC BY 4.0 — Wizards of the Coast)
// Mechanical data only — display strings (name, desc, range, duration) in i18n JSON files.

import { SPELLCASTING_CLASS } from './mechanics';

export const DND_SPELLS = [
  // ── Cantrips (0) ─────────────────────────────────────────────────────────
  {
    id: "acid_splash",
    level: 0,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "chill_touch",
    level: 0,
    school: "necromancy",
    classes: ["Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "dancing_lights",
    level: 0,
    school: "illusion",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "druidcraft",
    level: 0,
    school: "transmutation",
    classes: ["Druid"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "eldritch_blast",
    level: 0,
    school: "evocation",
    classes: ["Warlock"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "elementalism",
    level: 0,
    school: "transmutation",
    classes: ["Druid", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "fire_bolt",
    level: 0,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "guidance",
    level: 0,
    school: "divination",
    classes: ["Cleric", "Druid"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "light",
    level: 0,
    school: "evocation",
    classes: ["Bard", "Cleric", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "mage_hand",
    level: 0,
    school: "conjuration",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "mending",
    level: 0,
    school: "transmutation",
    classes: ["Bard", "Cleric", "Druid", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "message",
    level: 0,
    school: "transmutation",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "minor_illusion",
    level: 0,
    school: "illusion",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "poison_spray",
    level: 0,
    school: "evocation",
    classes: ["Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "prestidigitation",
    level: 0,
    school: "transmutation",
    classes: ["Bard", "Cleric", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "produce_flame",
    level: 0,
    school: "conjuration",
    classes: ["Druid"],
    c: false,
    r: false,
    actionType: "bonus",
  },
  {
    id: "ray_of_frost",
    level: 0,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "resistance",
    level: 0,
    school: "abjuration",
    classes: ["Cleric", "Druid"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "sacred_flame",
    level: 0,
    school: "evocation",
    classes: ["Cleric"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "shillelagh",
    level: 0,
    school: "transmutation",
    classes: ["Druid"],
    c: false,
    r: false,
    actionType: "bonus",
  },
  {
    id: "shocking_grasp",
    level: 0,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "sorcerous_burst",
    level: 0,
    school: "evocation",
    classes: ["Sorcerer"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "spare_the_dying",
    level: 0,
    school: "necromancy",
    classes: ["Cleric", "Druid"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "starry_wisp",
    level: 0,
    school: "evocation",
    classes: ["Bard", "Druid"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "thaumaturgy",
    level: 0,
    school: "transmutation",
    classes: ["Cleric"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "true_strike",
    level: 0,
    school: "divination",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "vicious_mockery",
    level: 0,
    school: "enchantment",
    classes: ["Bard"],
    c: false,
    r: false,
    actionType: "action",
  },
  // ── Level 1 ──────────────────────────────────────────────────────────────
  {
    id: "alarm",
    level: 1,
    school: "abjuration",
    classes: ["Ranger", "Wizard"],
    c: false,
    r: true,
    actionType: "minute",
  },
  {
    id: "animal_friendship",
    level: 1,
    school: "enchantment",
    classes: ["Bard", "Druid", "Ranger"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "bane",
    level: 1,
    school: "enchantment",
    classes: ["Bard", "Cleric", "Warlock"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "bless",
    level: 1,
    school: "enchantment",
    classes: ["Cleric", "Paladin"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "burning_hands",
    level: 1,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "charm_person",
    level: 1,
    school: "enchantment",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "chromatic_orb",
    level: 1,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "color_spray",
    level: 1,
    school: "illusion",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "command",
    level: 1,
    school: "enchantment",
    classes: ["Bard", "Cleric", "Paladin"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "cure_wounds",
    level: 1,
    school: "abjuration",
    classes: ["Bard", "Cleric", "Druid", "Ranger"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "comprehend_languages",
    level: 1,
    school: "divination",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: true,
    actionType: "action",
  },
  {
    id: "create_or_destroy_water",
    level: 1,
    school: "transmutation",
    classes: ["Cleric", "Druid"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "detect_magic",
    level: 1,
    school: "divination",
    classes: [
      "Bard",
      "Cleric",
      "Druid",
      "Ranger",
      "Sorcerer",
      "Warlock",
      "Wizard",
    ],
    c: true,
    r: true,
    actionType: "action",
  },
  {
    id: "divine_smite",
    level: 1,
    school: "evocation",
    classes: ["Paladin"],
    c: false,
    r: false,
    actionType: "bonus",
  },
  {
    id: "detect_evil_and_good",
    level: 1,
    school: "divination",
    classes: ["Cleric", "Paladin"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "detect_poison_and_disease",
    level: 1,
    school: "divination",
    classes: ["Cleric", "Druid", "Paladin", "Ranger"],
    c: true,
    r: true,
    actionType: "action",
  },
  {
    id: "divine_favor",
    level: 1,
    school: "transmutation",
    classes: ["Paladin"],
    c: false,
    r: false,
    actionType: "bonus",
  },
  {
    id: "ensnaring_strike",
    level: 1,
    school: "conjuration",
    classes: ["Ranger"],
    c: true,
    r: false,
    actionType: "bonus",
  },
  {
    id: "enhance_ability",
    level: 1,
    school: "transmutation",
    classes: ["Bard", "Cleric", "Druid", "Ranger", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "disguise_self",
    level: 1,
    school: "illusion",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "dissonant_whispers",
    level: 1,
    school: "enchantment",
    classes: ["Bard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "divine_favor",
    level: 1,
    school: "transmutation",
    classes: ["Paladin"],
    c: false,
    r: false,
    actionType: "bonus",
  },
  {
    id: "entangle",
    level: 1,
    school: "conjuration",
    classes: ["Druid", "Ranger"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "expeditious_retreat",
    level: 1,
    school: "transmutation",
    classes: ["Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "bonus",
  },
  {
    id: "faerie_fire",
    level: 1,
    school: "evocation",
    classes: ["Bard", "Druid"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "feather_fall",
    level: 1,
    school: "transmutation",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "reaction",
  },
  {
    id: "false_life",
    level: 1,
    school: "necromancy",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "find_familiar",
    level: 1,
    school: "conjuration",
    classes: ["Wizard"],
    c: false,
    r: true,
    actionType: "minute",
  },
  {
    id: "floating_disk",
    level: 1,
    school: "conjuration",
    classes: ["Wizard"],
    c: false,
    r: true,
    actionType: "action",
  },
  {
    id: "fog_cloud",
    level: 1,
    school: "conjuration",
    classes: ["Druid", "Ranger", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "hellish_rebuke",
    level: 1,
    school: "evocation",
    classes: ["Warlock"],
    c: false,
    r: false,
    actionType: "reaction",
  },
  {
    id: "goodberry",
    level: 1,
    school: "conjuration",
    classes: ["Druid", "Ranger"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "grease",
    level: 1,
    school: "conjuration",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "guiding_bolt",
    level: 1,
    school: "evocation",
    classes: ["Cleric"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "healing_word",
    level: 1,
    school: "abjuration",
    classes: ["Bard", "Cleric", "Druid"],
    c: false,
    r: false,
    actionType: "bonus",
  },
  {
    id: "heroism",
    level: 1,
    school: "enchantment",
    classes: ["Bard", "Paladin"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "hex",
    level: 1,
    school: "enchantment",
    classes: ["Warlock"],
    c: true,
    r: false,
    actionType: "bonus",
  },
  {
    id: "hideous_laughter",
    level: 1,
    school: "enchantment",
    classes: ["Bard", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "hunters_mark",
    level: 1,
    school: "divination",
    classes: ["Ranger"],
    c: true,
    r: false,
    actionType: "bonus",
  },
  {
    id: "ice_knife",
    level: 1,
    school: "conjuration",
    classes: ["Druid", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "identify",
    level: 1,
    school: "divination",
    classes: ["Bard", "Wizard"],
    c: false,
    r: true,
    actionType: "minute",
  },
  {
    id: "illusory_script",
    level: 1,
    school: "illusion",
    classes: ["Bard", "Warlock", "Wizard"],
    c: false,
    r: true,
    actionType: "minute",
  },
  {
    id: "inflict_wounds",
    level: 1,
    school: "necromancy",
    classes: ["Cleric"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "longstrider",
    level: 1,
    school: "transmutation",
    classes: ["Bard", "Druid", "Ranger", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "mage_armor",
    level: 1,
    school: "abjuration",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "magic_missile",
    level: 1,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "purify_food_and_drink",
    level: 1,
    school: "transmutation",
    classes: ["Cleric", "Druid", "Paladin"],
    c: false,
    r: true,
    actionType: "action",
  },
  {
    id: "ray_of_sickness",
    level: 1,
    school: "necromancy",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "sanctuary",
    level: 1,
    school: "abjuration",
    classes: ["Cleric"],
    c: false,
    r: false,
    actionType: "bonus",
  },
  {
    id: "shield",
    level: 1,
    school: "abjuration",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "reaction",
  },
  {
    id: "shield_of_faith",
    level: 1,
    school: "abjuration",
    classes: ["Cleric", "Paladin"],
    c: true,
    r: false,
    actionType: "bonus",
  },
  {
    id: "silent_image",
    level: 1,
    school: "illusion",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "sleep",
    level: 1,
    school: "enchantment",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "speak_with_animals",
    level: 1,
    school: "divination",
    classes: ["Bard", "Druid", "Ranger", "Warlock"],
    c: false,
    r: true,
    actionType: "action",
  },
  {
    id: "strength",
    level: 1,
    school: "enchantment",
    classes: ["Bard", "Druid", "Ranger"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "thunderwave",
    level: 1,
    school: "evocation",
    classes: ["Bard", "Druid", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "unseen_servant",
    level: 1,
    school: "conjuration",
    classes: ["Bard", "Warlock", "Wizard"],
    c: false,
    r: true,
    actionType: "action",
  },
  // ── Level 2 ──────────────────────────────────────────────────────────────
  {
    id: "acid_arrow",
    level: 2,
    school: "evocation",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "aid",
    level: 2,
    school: "abjuration",
    classes: ["Bard", "Cleric", "Paladin"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "alter_self",
    level: 2,
    school: "transmutation",
    classes: ["Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "animal_messenger",
    level: 2,
    school: "enchantment",
    classes: ["Bard", "Druid", "Ranger"],
    c: false,
    r: true,
    actionType: "action",
  },
  {
    id: "arcane_lock",
    level: 2,
    school: "abjuration",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "arcanists_magic_aura",
    level: 2,
    school: "illusion",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "augury",
    level: 2,
    school: "divination",
    classes: ["Cleric", "Druid", "Wizard"],
    c: false,
    r: true,
    actionType: "minute",
  },
  {
    id: "barkskin",
    level: 2,
    school: "transmutation",
    classes: ["Druid", "Ranger"],
    c: false,
    r: false,
    actionType: "bonus",
  },
  {
    id: "blindnessdeafness",
    level: 2,
    school: "transmutation",
    classes: ["Bard", "Cleric", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "blur",
    level: 2,
    school: "illusion",
    classes: ["Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "darkvision",
    level: 2,
    school: "transmutation",
    classes: ["Druid", "Ranger", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "calm_emotions",
    level: 2,
    school: "enchantment",
    classes: ["Bard", "Cleric"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "continual_flame",
    level: 2,
    school: "evocation",
    classes: ["Cleric", "Druid", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "darkness",
    level: 2,
    school: "evocation",
    classes: ["Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "detect_thoughts",
    level: 2,
    school: "divination",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "dragons_breath",
    level: 2,
    school: "transmutation",
    classes: ["Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "bonus",
  },
  {
    id: "enlargereduce",
    level: 2,
    school: "transmutation",
    classes: ["Bard", "Druid", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "enthrall",
    level: 2,
    school: "enchantment",
    classes: ["Bard", "Warlock"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "find_steed",
    level: 2,
    school: "conjuration",
    classes: ["Paladin"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "geas",
    level: 2,
    school: "enchantment",
    classes: ["Bard", "Cleric", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "hold_person",
    level: 2,
    school: "enchantment",
    classes: [
      "Bard",
      "Cleric",
      "Druid",
      "Ranger",
      "Sorcerer",
      "Warlock",
      "Wizard",
    ],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "find_traps",
    level: 2,
    school: "divination",
    classes: ["Cleric", "Druid", "Ranger"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "flame_blade",
    level: 2,
    school: "evocation",
    classes: ["Druid", "Sorcerer"],
    c: true,
    r: false,
    actionType: "bonus",
  },
  {
    id: "flaming_sphere",
    level: 2,
    school: "conjuration",
    classes: ["Druid", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "gentle_repose",
    level: 2,
    school: "necromancy",
    classes: ["Cleric", "Paladin", "Wizard"],
    c: false,
    r: true,
    actionType: "action",
  },
  {
    id: "gust_of_wind",
    level: 2,
    school: "evocation",
    classes: ["Druid", "Ranger", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "heat_metal",
    level: 2,
    school: "transmutation",
    classes: ["Bard", "Druid"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "invisibility",
    level: 2,
    school: "illusion",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "knock",
    level: 2,
    school: "transmutation",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "lesser_restoration",
    level: 2,
    school: "abjuration",
    classes: ["Bard", "Cleric", "Druid", "Paladin", "Ranger"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "levitate",
    level: 2,
    school: "transmutation",
    classes: ["Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "locate_creature",
    level: 2,
    school: "divination",
    classes: [
      "Bard",
      "Cleric",
      "Druid",
      "Paladin",
      "Ranger",
      "Sorcerer",
      "Warlock",
      "Wizard",
    ],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "locate_object",
    level: 2,
    school: "divination",
    classes: [
      "Bard",
      "Cleric",
      "Druid",
      "Paladin",
      "Ranger",
      "Sorcerer",
      "Warlock",
      "Wizard",
    ],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "locate_animals_or_plants",
    level: 2,
    school: "divination",
    classes: ["Bard", "Druid", "Ranger"],
    c: false,
    r: true,
    actionType: "action",
  },
  {
    id: "magic_mouth",
    level: 2,
    school: "illusion",
    classes: ["Bard", "Wizard"],
    c: false,
    r: true,
    actionType: "minute",
  },
  {
    id: "magic_weapon",
    level: 2,
    school: "transmutation",
    classes: ["Bard", "Cleric", "Paladin", "Ranger", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "bonus",
  },
  {
    id: "mind_spike",
    level: 2,
    school: "divination",
    classes: ["Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "mirror_image",
    level: 2,
    school: "illusion",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "misty_step",
    level: 2,
    school: "conjuration",
    classes: ["Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "bonus",
  },
  {
    id: "moonbeam",
    level: 2,
    school: "evocation",
    classes: ["Druid"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "pass_without_trace",
    level: 2,
    school: "abjuration",
    classes: ["Druid", "Ranger"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "phantasmal_force",
    level: 2,
    school: "illusion",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "prayer_of_healing",
    level: 2,
    school: "abjuration",
    classes: ["Cleric", "Paladin"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "protection_from_poison",
    level: 2,
    school: "abjuration",
    classes: ["Cleric", "Druid", "Paladin", "Ranger"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "ray_of_enfeeblement",
    level: 2,
    school: "necromancy",
    classes: ["Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "rope_trick",
    level: 2,
    school: "transmutation",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "scorching_ray",
    level: 2,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "searing_smite",
    level: 2,
    school: "evocation",
    classes: ["Paladin", "Ranger"],
    c: true,
    r: false,
    actionType: "bonus",
  },
  {
    id: "see_invisibility",
    level: 2,
    school: "divination",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "shining_smite",
    level: 2,
    school: "evocation",
    classes: ["Paladin"],
    c: true,
    r: false,
    actionType: "bonus",
  },
  {
    id: "shatter",
    level: 2,
    school: "evocation",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "silence",
    level: 2,
    school: "illusion",
    classes: ["Bard", "Cleric", "Ranger"],
    c: true,
    r: true,
    actionType: "action",
  },
  {
    id: "spider_climb",
    level: 2,
    school: "transmutation",
    classes: ["Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "spike_growth",
    level: 2,
    school: "transmutation",
    classes: ["Druid", "Ranger"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "suggestion",
    level: 2,
    school: "enchantment",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "spiritual_weapon",
    level: 2,
    school: "evocation",
    classes: ["Cleric"],
    c: true,
    r: false,
    actionType: "bonus",
  },
  {
    id: "warding_bond",
    level: 2,
    school: "abjuration",
    classes: ["Cleric", "Paladin"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "web",
    level: 2,
    school: "conjuration",
    classes: ["Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "zone_of_truth",
    level: 2,
    school: "enchantment",
    classes: ["Bard", "Cleric", "Paladin"],
    c: false,
    r: false,
    actionType: "action",
  },
  // ── Level 3 ──────────────────────────────────────────────────────────────
  {
    id: "animate_dead",
    level: 3,
    school: "necromancy",
    classes: ["Cleric", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "beacon_of_hope",
    level: 3,
    school: "abjuration",
    classes: ["Cleric"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "daylight",
    level: 3,
    school: "evocation",
    classes: [
      "Bard",
      "Cleric",
      "Druid",
      "Paladin",
      "Ranger",
      "Sorcerer",
      "Wizard",
    ],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "dispel_magic",
    level: 3,
    school: "abjuration",
    classes: [
      "Bard",
      "Cleric",
      "Druid",
      "Paladin",
      "Ranger",
      "Sorcerer",
      "Warlock",
      "Wizard",
    ],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "bestow_curse",
    level: 3,
    school: "necromancy",
    classes: ["Bard", "Cleric", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "blink",
    level: 3,
    school: "transmutation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "call_lightning",
    level: 3,
    school: "conjuration",
    classes: ["Druid"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "clairvoyance",
    level: 3,
    school: "divination",
    classes: ["Bard", "Cleric", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "minute",
  },
  {
    id: "conjure_animals",
    level: 3,
    school: "conjuration",
    classes: ["Druid", "Ranger"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "create_food_and_water",
    level: 3,
    school: "conjuration",
    classes: ["Cleric", "Paladin"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "fear",
    level: 3,
    school: "illusion",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "fireball",
    level: 3,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "fly",
    level: 3,
    school: "transmutation",
    classes: ["Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "gaseous_form",
    level: 3,
    school: "transmutation",
    classes: ["Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "glyph_of_warding",
    level: 3,
    school: "abjuration",
    classes: ["Bard", "Cleric", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "haste",
    level: 3,
    school: "transmutation",
    classes: ["Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "hypnotic_pattern",
    level: 3,
    school: "illusion",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "lightning_bolt",
    level: 3,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "magic_circle",
    level: 3,
    school: "abjuration",
    classes: ["Cleric", "Paladin", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "major_image",
    level: 3,
    school: "illusion",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "mass_healing_word",
    level: 3,
    school: "abjuration",
    classes: ["Bard", "Cleric"],
    c: false,
    r: false,
    actionType: "bonus",
  },
  {
    id: "meld_into_stone",
    level: 3,
    school: "transmutation",
    classes: ["Cleric", "Druid", "Ranger"],
    c: false,
    r: true,
    actionType: "action",
  },
  {
    id: "nondetection",
    level: 3,
    school: "abjuration",
    classes: ["Bard", "Ranger", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "phantom_steed",
    level: 3,
    school: "illusion",
    classes: ["Wizard"],
    c: false,
    r: true,
    actionType: "minute",
  },
  {
    id: "remove_curse",
    level: 3,
    school: "abjuration",
    classes: ["Cleric", "Paladin", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "revivify",
    level: 3,
    school: "necromancy",
    classes: ["Cleric", "Druid", "Paladin", "Ranger"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "sending",
    level: 3,
    school: "divination",
    classes: ["Bard", "Cleric", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "sleet_storm",
    level: 3,
    school: "conjuration",
    classes: ["Druid", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "slow",
    level: 3,
    school: "transmutation",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "speak_with_dead",
    level: 3,
    school: "necromancy",
    classes: ["Bard", "Cleric", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "speak_with_plants",
    level: 3,
    school: "transmutation",
    classes: ["Bard", "Druid", "Ranger"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "spirit_guardians",
    level: 3,
    school: "conjuration",
    classes: ["Cleric"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "stinking_cloud",
    level: 3,
    school: "conjuration",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "tiny_hut",
    level: 3,
    school: "evocation",
    classes: ["Bard", "Wizard"],
    c: false,
    r: true,
    actionType: "minute",
  },
  {
    id: "tongues",
    level: 3,
    school: "divination",
    classes: ["Bard", "Cleric", "Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "vampiric_touch",
    level: 3,
    school: "necromancy",
    classes: ["Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "water_breathing",
    level: 3,
    school: "transmutation",
    classes: ["Druid", "Ranger", "Sorcerer", "Wizard"],
    c: false,
    r: true,
    actionType: "action",
  },
  {
    id: "water_walk",
    level: 3,
    school: "transmutation",
    classes: ["Cleric", "Druid", "Ranger", "Sorcerer"],
    c: false,
    r: true,
    actionType: "action",
  },
  {
    id: "wind_wall",
    level: 3,
    school: "evocation",
    classes: ["Druid", "Ranger"],
    c: true,
    r: false,
    actionType: "action",
  },
  // ── Level 4 ──────────────────────────────────────────────────────────────
  {
    id: "arcane_eye",
    level: 4,
    school: "divination",
    classes: ["Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "aura_of_life",
    level: 4,
    school: "abjuration",
    classes: ["Cleric", "Paladin"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "banishment",
    level: 4,
    school: "abjuration",
    classes: ["Cleric", "Paladin", "Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "black_tentacles",
    level: 4,
    school: "conjuration",
    classes: ["Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "compulsion",
    level: 4,
    school: "enchantment",
    classes: ["Bard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "confusion",
    level: 4,
    school: "enchantment",
    classes: ["Bard", "Druid", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "conjure_minor_elementals",
    level: 4,
    school: "conjuration",
    classes: ["Druid", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "conjure_woodland_beings",
    level: 4,
    school: "conjuration",
    classes: ["Druid", "Ranger"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "control_water",
    level: 4,
    school: "transmutation",
    classes: ["Cleric", "Druid", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "death_ward",
    level: 4,
    school: "abjuration",
    classes: ["Cleric", "Paladin"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "dimension_door",
    level: 4,
    school: "conjuration",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "divination",
    level: 4,
    school: "divination",
    classes: ["Cleric", "Druid", "Wizard"],
    c: false,
    r: true,
    actionType: "action",
  },
  {
    id: "dominate_beast",
    level: 4,
    school: "enchantment",
    classes: ["Druid", "Ranger", "Sorcerer"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "fabricate",
    level: 4,
    school: "transmutation",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "faithful_hound",
    level: 4,
    school: "conjuration",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "fire_shield",
    level: 4,
    school: "evocation",
    classes: ["Druid", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "freedom_of_movement",
    level: 4,
    school: "abjuration",
    classes: ["Bard", "Cleric", "Druid", "Ranger"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "giant_insect",
    level: 4,
    school: "conjuration",
    classes: ["Druid"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "greater_invisibility",
    level: 4,
    school: "illusion",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "guardian_of_faith",
    level: 4,
    school: "conjuration",
    classes: ["Cleric"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "hallucinatory_terrain",
    level: 4,
    school: "illusion",
    classes: ["Bard", "Druid", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "hold_monster",
    level: 4,
    school: "enchantment",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "ice_storm",
    level: 4,
    school: "evocation",
    classes: ["Druid", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "phantasmal_killer",
    level: 4,
    school: "illusion",
    classes: ["Bard", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "polymorph",
    level: 4,
    school: "transmutation",
    classes: ["Bard", "Druid", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "private_sanctum",
    level: 4,
    school: "abjuration",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "resilient_sphere",
    level: 4,
    school: "abjuration",
    classes: ["Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "secret_chest",
    level: 4,
    school: "conjuration",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "stone_shape",
    level: 4,
    school: "transmutation",
    classes: ["Cleric", "Druid", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "stoneskin",
    level: 4,
    school: "abjuration",
    classes: ["Druid", "Ranger", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "vitriolic_sphere",
    level: 4,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "wall_of_fire",
    level: 4,
    school: "evocation",
    classes: ["Druid", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  // ── Level 5 ──────────────────────────────────────────────────────────────
  {
    id: "animate_objects",
    level: 5,
    school: "transmutation",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "antilife_shell",
    level: 5,
    school: "abjuration",
    classes: ["Druid"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "arcane_hand",
    level: 5,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "awaken",
    level: 5,
    school: "transmutation",
    classes: ["Bard", "Druid"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "cloudkill",
    level: 5,
    school: "conjuration",
    classes: ["Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "commune",
    level: 5,
    school: "divination",
    classes: ["Cleric"],
    c: false,
    r: true,
    actionType: "minute",
  },
  {
    id: "commune_with_nature",
    level: 5,
    school: "divination",
    classes: ["Druid", "Ranger"],
    c: false,
    r: true,
    actionType: "minute",
  },
  {
    id: "cone_of_cold",
    level: 5,
    school: "evocation",
    classes: ["Druid", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "conjure_elemental",
    level: 5,
    school: "conjuration",
    classes: ["Druid", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "contact_other_plane",
    level: 5,
    school: "divination",
    classes: ["Warlock", "Wizard"],
    c: false,
    r: true,
    actionType: "minute",
  },
  {
    id: "contagion",
    level: 5,
    school: "necromancy",
    classes: ["Cleric", "Druid"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "creation",
    level: 5,
    school: "illusion",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "dispel_evil_and_good",
    level: 5,
    school: "abjuration",
    classes: ["Cleric", "Paladin"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "dominate_person",
    level: 5,
    school: "enchantment",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "dream",
    level: 5,
    school: "illusion",
    classes: ["Bard", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "flame_strike",
    level: 5,
    school: "evocation",
    classes: ["Cleric"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "greater_restoration",
    level: 5,
    school: "abjuration",
    classes: ["Bard", "Cleric", "Druid"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "hallow",
    level: 5,
    school: "abjuration",
    classes: ["Cleric"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "insect_plague",
    level: 5,
    school: "conjuration",
    classes: ["Cleric", "Druid", "Sorcerer"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "legend_lore",
    level: 5,
    school: "divination",
    classes: ["Bard", "Cleric", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "mass_cure_wounds",
    level: 5,
    school: "abjuration",
    classes: ["Bard", "Cleric", "Druid"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "mislead",
    level: 5,
    school: "illusion",
    classes: ["Bard", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "modify_memory",
    level: 5,
    school: "enchantment",
    classes: ["Bard", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "passwall",
    level: 5,
    school: "transmutation",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "planar_binding",
    level: 5,
    school: "abjuration",
    classes: ["Bard", "Cleric", "Wizard"],
    c: true,
    r: false,
    actionType: "minute",
  },
  {
    id: "plane_shift",
    level: 5,
    school: "conjuration",
    classes: ["Cleric", "Druid", "Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "raise_dead",
    level: 5,
    school: "necromancy",
    classes: ["Bard", "Cleric", "Paladin"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "reincarnate",
    level: 5,
    school: "necromancy",
    classes: ["Druid"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "seeming",
    level: 5,
    school: "illusion",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "summon_dragon",
    level: 5,
    school: "conjuration",
    classes: ["Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "telekinesis",
    level: 5,
    school: "transmutation",
    classes: ["Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "telepathic_bond",
    level: 5,
    school: "divination",
    classes: ["Bard", "Wizard"],
    c: false,
    r: true,
    actionType: "action",
  },
  {
    id: "teleportation_circle",
    level: 5,
    school: "conjuration",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "tree_stride",
    level: 5,
    school: "conjuration",
    classes: ["Druid", "Ranger"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "wall_of_force",
    level: 5,
    school: "evocation",
    classes: ["Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "wall_of_stone",
    level: 5,
    school: "evocation",
    classes: ["Druid", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  // ── Level 6 ──────────────────────────────────────────────────────────────
  {
    id: "blade_barrier",
    level: 6,
    school: "evocation",
    classes: ["Cleric"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "chain_lightning",
    level: 6,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "circle_of_death",
    level: 6,
    school: "necromancy",
    classes: ["Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "conjure_fey",
    level: 6,
    school: "conjuration",
    classes: ["Druid"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "contingency",
    level: 6,
    school: "abjuration",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "create_undead",
    level: 6,
    school: "necromancy",
    classes: ["Cleric", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "disintegrate",
    level: 6,
    school: "transmutation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "eyebite",
    level: 6,
    school: "necromancy",
    classes: ["Bard", "Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "find_the_path",
    level: 6,
    school: "divination",
    classes: ["Bard", "Cleric", "Druid"],
    c: true,
    r: false,
    actionType: "minute",
  },
  {
    id: "flesh_to_stone",
    level: 6,
    school: "transmutation",
    classes: ["Druid", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "forbiddance",
    level: 6,
    school: "abjuration",
    classes: ["Cleric"],
    c: false,
    r: true,
    actionType: "minute",
  },
  {
    id: "freezing_sphere",
    level: 6,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "globe_of_invulnerability",
    level: 6,
    school: "abjuration",
    classes: ["Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "guards_and_wards",
    level: 6,
    school: "abjuration",
    classes: ["Bard", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "harm",
    level: 6,
    school: "necromancy",
    classes: ["Cleric"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "heal",
    level: 6,
    school: "abjuration",
    classes: ["Cleric", "Druid"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "heroes_feast",
    level: 6,
    school: "conjuration",
    classes: ["Bard", "Cleric", "Druid"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "instant_summons",
    level: 6,
    school: "conjuration",
    classes: ["Wizard"],
    c: false,
    r: true,
    actionType: "minute",
  },
  {
    id: "irresistible_dance",
    level: 6,
    school: "enchantment",
    classes: ["Bard", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "magic_jar",
    level: 6,
    school: "necromancy",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "mass_suggestion",
    level: 6,
    school: "enchantment",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "move_earth",
    level: 6,
    school: "transmutation",
    classes: ["Druid", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "planar_ally",
    level: 6,
    school: "conjuration",
    classes: ["Cleric"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "programmed_illusion",
    level: 6,
    school: "illusion",
    classes: ["Bard", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "sunbeam",
    level: 6,
    school: "evocation",
    classes: ["Cleric", "Druid", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "transport_via_plants",
    level: 6,
    school: "conjuration",
    classes: ["Druid"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "true_seeing",
    level: 6,
    school: "divination",
    classes: ["Bard", "Cleric", "Druid", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "wall_of_ice",
    level: 6,
    school: "evocation",
    classes: ["Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "wall_of_thorns",
    level: 6,
    school: "conjuration",
    classes: ["Druid"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "wind_walk",
    level: 6,
    school: "transmutation",
    classes: ["Druid"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "word_of_recall",
    level: 6,
    school: "conjuration",
    classes: ["Cleric"],
    c: false,
    r: false,
    actionType: "action",
  },
  // ── Level 7 ──────────────────────────────────────────────────────────────
  {
    id: "arcane_sword",
    level: 7,
    school: "evocation",
    classes: ["Bard", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "conjure_celestial",
    level: 7,
    school: "conjuration",
    classes: ["Cleric"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "delayed_blast_fireball",
    level: 7,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "divine_word",
    level: 7,
    school: "evocation",
    classes: ["Cleric"],
    c: false,
    r: false,
    actionType: "bonus",
  },
  {
    id: "finger_of_death",
    level: 7,
    school: "necromancy",
    classes: ["Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "fire_storm",
    level: 7,
    school: "evocation",
    classes: ["Cleric", "Druid", "Sorcerer"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "forcecage",
    level: 7,
    school: "evocation",
    classes: ["Bard", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "magnificent_mansion",
    level: 7,
    school: "conjuration",
    classes: ["Bard", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "mirage_arcane",
    level: 7,
    school: "illusion",
    classes: ["Bard", "Druid", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "prismatic_spray",
    level: 7,
    school: "evocation",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "project_image",
    level: 7,
    school: "illusion",
    classes: ["Bard", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "regenerate",
    level: 7,
    school: "transmutation",
    classes: ["Bard", "Cleric", "Druid"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "resurrection",
    level: 7,
    school: "necromancy",
    classes: ["Bard", "Cleric"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "reverse_gravity",
    level: 7,
    school: "transmutation",
    classes: ["Druid", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "sequester",
    level: 7,
    school: "transmutation",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "simulacrum",
    level: 7,
    school: "illusion",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "symbol",
    level: 7,
    school: "abjuration",
    classes: ["Bard", "Cleric", "Druid", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "teleport",
    level: 7,
    school: "conjuration",
    classes: ["Bard", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  // ── Level 8 ──────────────────────────────────────────────────────────────
  {
    id: "animal_shapes",
    level: 8,
    school: "transmutation",
    classes: ["Druid"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "antimagic_field",
    level: 8,
    school: "abjuration",
    classes: ["Cleric", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "antipathysympathy",
    level: 8,
    school: "enchantment",
    classes: ["Bard", "Druid", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "befuddlement",
    level: 8,
    school: "enchantment",
    classes: ["Bard", "Druid", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "clone",
    level: 8,
    school: "necromancy",
    classes: ["Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "control_weather",
    level: 8,
    school: "transmutation",
    classes: ["Cleric", "Druid", "Wizard"],
    c: true,
    r: false,
    actionType: "minute",
  },
  {
    id: "demiplane",
    level: 8,
    school: "conjuration",
    classes: ["Sorcerer", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "earthquake",
    level: 8,
    school: "transmutation",
    classes: ["Cleric", "Druid", "Sorcerer"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "glibness",
    level: 8,
    school: "enchantment",
    classes: ["Bard", "Warlock"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "holy_aura",
    level: 8,
    school: "abjuration",
    classes: ["Cleric"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "incendiary_cloud",
    level: 8,
    school: "conjuration",
    classes: ["Druid", "Sorcerer", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "maze",
    level: 8,
    school: "conjuration",
    classes: ["Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "mind_blank",
    level: 8,
    school: "abjuration",
    classes: ["Bard", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "sunburst",
    level: 8,
    school: "evocation",
    classes: ["Cleric", "Druid", "Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "power_word_stun",
    level: 8,
    school: "enchantment",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "tsunami",
    level: 8,
    school: "conjuration",
    classes: ["Druid"],
    c: true,
    r: false,
    actionType: "minute",
  },
  // ── Level 9 ──────────────────────────────────────────────────────────────
  {
    id: "astral_projection",
    level: 9,
    school: "necromancy",
    classes: ["Cleric", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "foresight",
    level: 9,
    school: "divination",
    classes: ["Bard", "Druid", "Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "gate",
    level: 9,
    school: "conjuration",
    classes: ["Cleric", "Sorcerer", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "imprisonment",
    level: 9,
    school: "abjuration",
    classes: ["Warlock", "Wizard"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "mass_heal",
    level: 9,
    school: "abjuration",
    classes: ["Cleric"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "meteor_swarm",
    level: 9,
    school: "evocation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "power_word_heal",
    level: 9,
    school: "enchantment",
    classes: ["Bard", "Cleric"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "power_word_kill",
    level: 9,
    school: "enchantment",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "prismatic_wall",
    level: 9,
    school: "abjuration",
    classes: ["Bard", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "shapechange",
    level: 9,
    school: "transmutation",
    classes: ["Druid", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "storm_of_vengeance",
    level: 9,
    school: "conjuration",
    classes: ["Druid"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "time_stop",
    level: 9,
    school: "transmutation",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
  {
    id: "true_polymorph",
    level: 9,
    school: "transmutation",
    classes: ["Bard", "Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "true_resurrection",
    level: 9,
    school: "necromancy",
    classes: ["Cleric", "Druid"],
    c: false,
    r: false,
    actionType: "minute",
  },
  {
    id: "weird",
    level: 9,
    school: "illusion",
    classes: ["Warlock", "Wizard"],
    c: true,
    r: false,
    actionType: "action",
  },
  {
    id: "wish",
    level: 9,
    school: "conjuration",
    classes: ["Sorcerer", "Wizard"],
    c: false,
    r: false,
    actionType: "action",
  },
];


export const SCHOOLS = [
  "enchantment",
  "divination",
  "evocation",
  "illusion",
  "conjuration",
  "necromancy",
  "transmutation",
  "abjuration",
];

export const SPELL_CLASSES = Object.keys(SPELLCASTING_CLASS);

export function filterSpells({ spells, level, school, cls, search }) {
  return (spells || DND_SPELLS).filter((s) => {
    if (
      level !== undefined &&
      level !== null &&
      level !== "" &&
      parseInt(s.level) !== parseInt(level)
    )
      return false;
    if (school && s.school !== school) return false;
    if (cls && !s.classes.includes(cls)) return false;
    if (
      search &&
      !(s.name || s.id || "").toLowerCase().includes(search.toLowerCase())
    )
      return false;
    return true;
  });
}
